import { createActions } from '@manager-base/app-base/config/data-access';
import { BASE_PATH_API } from '@manager-base/app-base/environment/paths/constants';
import { SetupIntentDTO } from '@root/manager-base/data/dtos/payments/setup-intent.dto';

const baseRoute = `${BASE_PATH_API}/setupIntents`;

const actions = {
    createSetupIntent: {
        method: 'POST',
        url: baseRoute
    }
};

export interface ISetupIntentsApi {
    createSetupIntent(params: { stripeAccount: number }): Promise<SetupIntentDTO>
}

// eslint-disable-next-line prefer-arrow/prefer-arrow-functions
export function SetupIntentsApi(): ISetupIntentsApi {
    return createActions(actions);
}
